<script>
import {timeSince} from "@/state/helpers";
import {cloneDeep} from "lodash";

export default {
  props: {
    topbarNotifications: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      topbarNotificationsCopy: cloneDeep(this.topbarNotifications)
    }
  },
  computed: {
    userType() {
      return this.$store.getters['user/userType'];
    },
  },
  methods: {
    navigate(notification) {
      let routePrefix = this.userType === 'client' ? '/client' : '';
      if (notification.sourceable_type === 'CampaignAgreement') {
        this.$router.push(`${routePrefix}/offers-board/${notification.sourceable_id}`)
      }
      if (notification.sourceable_type === 'AgreedPost') {
        this.$router.push(`${routePrefix}/content-board/${notification.sourceable_id}`)
      }
    },
    timeSince: timeSince,
  }
}
</script>

<template>
  <div>
    <div v-if="topbarNotifications.length === 0" class="notification-item">
      <div class="media">
        {{ $t('No Unread Notifications') }}
      </div>
    </div>

    <div v-for="notification in topbarNotificationsCopy" :key="notification.id">
      <a @click="navigate(notification)" class="has-pointer-cursor text-reset notification-item">
        <div class="media">
          <div class="mr-3">
            <img v-if="notification.data.subject_picture_url" :src="`${notification.data.subject_picture_url}`" @error="notification.data.subject_picture_url=false" class="rounded-circle avatar-sm border-1 ml-minus-5" :alt="notification.data.subject_name" />
            <div v-else-if="notification.data.subject_name"  class="avatar-sm letter-in-circle-2 border-1 ml-minus-5" style="background: gray">{{ notification.data.subject_name.charAt(0) }}</div>
          </div>
          <div class="media-body">
            <p class="mt-0 mb-1" v-html="$options.filters.markdownText(notification.data.title)"></p>
            <div class="font-size-12 text-muted">
              <p class="mb-0">
                <i class="mdi mdi-clock-outline"></i>
                {{ timeSince(notification.created_at) }} ago
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
